export const TOAST_DEFAULT_DURATION = 8000; // ms
